import {getApiUrl} from "../../config";
import {useEffect, useState} from "react";
import AudioPlayer from "../../components/AudioPlayer/AudioPlayer.tsx";
import {PhoneHQButton, PhoneHQGlyph} from 'ch3-ui-lib';

const RecordingDownload = () => {

    const currentUrl = window.location.href;
    const urlParams = new URL(currentUrl);
    const recordingId = urlParams.pathname.split('/').pop();
    const hsParam = urlParams.searchParams.get('hs');


    const [source, setSource] = useState<string | null>(null);
    const [blob, setBlob] = useState<Blob | null>(null);
    const [filename, setFilename] = useState<string>(`recording-${recordingId}.mp3`);

    useEffect( () => {
        const fetchRecording = async () => {
            const apiUrl = await getApiUrl();
            const downloadUrl = `${apiUrl}/api/v1/recordings/shared/${recordingId}?hs=${hsParam}`;

            const response = await fetch(downloadUrl).then(
                (res) => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    const headersObj = Object.fromEntries(res.headers.entries());
                    console.log("Response headers:", headersObj);
                    return res;
                }
            );
            const resBlob = await response.blob();

            const contentDisposition = response.headers.get('Content-Disposition');
            const headersObj = Object.fromEntries(response.headers.entries());
            console.log("All headers:", headersObj);
            let filename = `recording-${recordingId}.mp3`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, '');
                    console.log("Filename extracted:", filename);
                    setFilename(filename);
                }
            }

            setBlob(resBlob);
            const blobUrl = window.URL.createObjectURL(resBlob);
            setSource(blobUrl);

            return () => {
                window.URL.revokeObjectURL(blobUrl);
            };
        }
        fetchRecording()
    }, [currentUrl]);



    const downloadRecording = async () => {




        if (recordingId && hsParam) {
            try {
                const blobUrl = window.URL.createObjectURL(blob as Blob);

                const anchor = document.createElement("a");
                anchor.href = blobUrl;
                anchor.download = filename;
                anchor.style.display = "none";

                document.body.appendChild(anchor);
                anchor.click();

                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(anchor);
            } catch (error) {
                console.error("Download failed:", error);
            }
        }
    };




    return (
        <div className={"items-center justify-center w-full p-4"}>
            {source && <AudioPlayer
                src={source}
            />}
            <div className={"flex flex-col items-center justify-center"}>
                <PhoneHQButton size="sm" onClick={() => {  downloadRecording()}} className="mt-4" phq-id='recordingDownload-downloadBtn' ><PhoneHQGlyph name="download" size={16}/>Download Recording</PhoneHQButton>
            </div>

        </div>
    );
};

export default RecordingDownload;
